export default function financeiro(podeAcessar) {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/fin/inicio',
    },
    {
      name: 'Recebimentos',
      icon: 'fa fa-usd fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo: !(
        podeAcessar('fin_rec_vis') == false &&
        podeAcessar('fin_rec_cad') == false &&
        podeAcessar('fin_rec_ident') == false
      ),
      children: [
        {
          name: 'Liberados',
          type: 'item',
          ativo: podeAcessar('fin_rec_vis'),
          link: '/app/fin/recebimentos/liberados-baixa',
        },
        {
          name: 'Bloqueados / a Identificar',
          type: 'item',
          ativo: podeAcessar('fin_rec_ident'),
          link: '/app/fin/recebimentos/bloqueados-identificar',
        },
        {
          name: 'Importar',
          type: 'item',
          ativo: podeAcessar('fin_rec_cad'),
          link: '/app/fin/recebimentos/importacoes',
          bloq: false,
        },
        {
          name: 'Importar e Baixar',
          type: 'item',
          ativo: true,
          link: '/app/fin/importar-recebimentos-baixas',
        },
      ],
    },
    {
      name: 'Baixas Realizadas',
      icon: 'fa fa-check-square-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_baixas_vis'),
      link: '/app/fin/baixas-realizadas',
    },
    {
      name: 'Prestação de Contas',
      icon: 'fa fa-usd fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_pc_vis'),
      link: '/app/fin/prestacao-contas',
    },
    {
      name: 'Repasses',
      icon: 'fa fa-usd fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_rep_vis'),
      link: '/app/fin/repasses',
    },
    {
      name: 'Faturamento / NFSe',
      icon: 'fa fa-heartbeat fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_nf'),
      link: '/app/fin/nota-fiscal',
    },
    {
      name: 'Faturas',
      icon: 'zmdi zmdi-hc-fw zmdi-receipt',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_fat_vis'),
      link: '/app/fin/faturas',
    },
    {
      name: 'Boletos Bancários',
      icon: 'fa fa-barcode fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_bol_vis'),
      link: '/app/fin/boletos',
    },
    {
      name: 'Pix QRCode',
      icon: 'fa fa-qrcode fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_pix_vis'),
      link: '/app/fin/pix',
    },
    {
      name: 'Cartão de Crédito',
      icon: 'fa fa-credit-card fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_cartao_vis'),
      link: '/app/fin/cartao',
    },
    {
      name: 'Cheques Recebidos',
      icon: 'fa fa-keyboard-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_cheq_vis'),
      link: '/app/fin/cheques',
    },
    {
      name: 'Gerencial',
      icon: 'fa fa-line-chart fa-fw',
      iconSize: '1.2em',
      type: 'collapse',
      ativo:
        podeAcessar('fin_crec_vis') ||
        podeAcessar('fin_cpag_vis') ||
        podeAcessar('fin_movc_vis'),
      children: [
        {
          name: 'Contas a Receber',
          icon: 'fa fa-plus-square-o',
          iconSize: '1.2em',
          type: 'item',
          ativo: podeAcessar('fin_crec_vis'),
          link: '/app/fin/contas-a-receber',
        },
        {
          name: 'Contas a Pagar',
          icon: 'fa fa-minus-square-o',
          iconSize: '1.2em',
          type: 'item',
          ativo: podeAcessar('fin_cpag_vis'),
          link: '/app/fin/contas-a-pagar',
        },
        {
          name: 'Movimentações',
          icon: 'fa fa-money',
          iconSize: '1.2em',
          type: 'item',
          ativo: podeAcessar('fin_movc_vis'),
          link: '/app/fin/mov-contas',
        },
      ],
    },
    {
      name: 'Tá Pago - Alega Pagto',
      icon: 'zmdi zmdi-hc-fw zmdi-desktop-windows',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('fin_alega_pag'),
      link: '/app/fin/portal-alega-pagamento',
    },
    {
      name: 'Instruções ao Financeiro',
      icon: 'fa fa-bell-o fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/fin/instrucoes-negociadores',
    },
  ];
}
